import { Link, NavLink, Navigate, useLocation } from "react-router-dom";
import { useReader } from "../../context/ReaderContext";
import { BrandLoader } from "../../components/site/Logo";
import { Seo } from "../../components/site/Seo";

export const inputCls = "h-11 w-full rounded-sm border border-input bg-card px-3 text-[15px] outline-none focus:border-ink focus:ring-1 focus:ring-ink";
export const btnMain = "inline-flex min-h-[44px] items-center justify-center gap-2 rounded-sm bg-navy px-5 text-sm font-bold text-white transition-colors hover:bg-navy-700 disabled:opacity-50 dark:bg-pulse";
export const btnLine = "inline-flex min-h-[44px] items-center justify-center gap-2 rounded-sm border border-border bg-card px-4 text-sm font-semibold transition-colors hover:border-ink disabled:opacity-50";

const TABS = [["/moj-balkan-info", "Pregled"], ["/moje-vijesti", "Moje vijesti"], ["/sacuvano", "Sačuvano"], ["/obavjestenja", "Obavještenja"], ["/moj-profil", "Profil"], ["/postavke-privatnosti", "Privatnost"]];

export const ReaderTabs = () => (
  <nav aria-label="MOJ BALKAN INFO" className="-mx-4 mt-6 overflow-x-auto border-b border-rule px-4 sm:mx-0 sm:px-0" data-testid="reader-tabs">
    <div className="flex gap-6">
      {TABS.map(([to, l]) => (
        <NavLink key={to} to={to} end className={({ isActive }) => `whitespace-nowrap border-b-[3px] py-3 text-[13.5px] font-bold transition-colors ${isActive ? "border-pulse text-ink" : "border-transparent text-muted-foreground hover:text-ink"}`} data-testid={`reader-tab-${to.slice(1)}`}>{l}</NavLink>
      ))}
    </div>
  </nav>
);

export const ReaderPage = ({ title, intro, children, testId, tabs = true }) => (
  <div className="container-news max-w-5xl pb-16" data-testid={testId}>
    <Seo title={title} noindex />
    <header className="pt-8 md:pt-12">
      <p className="kicker mb-2">MOJ BALKAN INFO</p>
      <h1 className="hl text-[1.9rem] leading-[1.1] sm:text-[2.4rem]">{title}</h1>
      {intro && <p className="dek mt-3 max-w-2xl text-[0.98rem] text-muted-foreground">{intro}</p>}
    </header>
    {tabs && <ReaderTabs />}
    <div className="mt-8">{children}</div>
  </div>
);

export const RequireReader = ({ children }) => {
  const { reader } = useReader();
  const loc = useLocation();
  if (reader === null) return <BrandLoader label="Provjera prijave…" />;
  if (!reader) return <Navigate to="/prijava" replace state={{ from: loc.pathname }} />;
  return children;
};

export const GuestNote = () => (
  <p className="rounded-sm border border-border bg-surface p-4 text-sm" data-testid="guest-login-note">
    Ova stranica je dostupna uz čitalački račun. <Link to="/prijava" className="font-semibold underline">Prijavi se</Link> ili <Link to="/registracija" className="font-semibold underline">otvori besplatan račun</Link>.
  </p>
);
